import axios from "axios";
import { alertAction, loaderAction, userAction } from "../actions";
import { NETWORK_API_ERROR_MESSAGE } from "../constants/Constant";

export const httpInterceptor = (store) => {
  const { dispatch } = store;

  axios.interceptors.request.use((config) => {
    if (!config?.url.includes("dashboard")) {
      dispatch(loaderAction.showLoader());
    }
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.accessToken) {
      config.headers = { Authorization: `Bearer ${user.accessToken}` };
    }
    return config;
  });
  const UNAUTHORIZED = 401;

  axios.interceptors.response.use(
    (response) => {
      if (!response.config.url.includes("dashboard")) {
        dispatch(loaderAction.hideLoader());
      }
      return response;
    },
    (error) => {
      if (!error.config.url.includes("dashboard")) {
        dispatch(loaderAction.hideLoader());
      }
      const status = error?.response?.status;
      
      if (status === undefined) {
        dispatch(alertAction.showNetworkAPIErrorMessage(NETWORK_API_ERROR_MESSAGE, userAction.logout));
      } else if (status === UNAUTHORIZED) {
        dispatch(userAction.logout());
        window.location.href= "/login"
      }else dispatch(alertAction.showErrorMessage(error));

      return Promise.reject(error);
    }
  );
};
